<template>
	<div>
		<div v-if="isSalvadorProgram()">
			<main class="wrapper-parallax">

				<section class="section-1  parallax bg1">
					<div class="home-landing">

						<el-row class="landing-frame">

							<el-col align="center"
							        :xs="{ span: 24, offset:0}"
							        :sm="{ span: 24, offset:0}"
							        :md="{ span: 18, offset: 3}"
							        :lg="{ span: 12, offset:6}"
							        :xl="{ span: 12, offset: 6}">
								<div class="landing-middle all-padding">
									<p class="landing-text text-color-gray">
										Jóvenes Construyendo el Futuro en El Salvador es un programa que busca que
										jóvenes entre 18 a 29 años de edad puedan capacitarse en el trabajo. El Fondo
										México por medio de la Agencia Mexicana de Cooperación Internacional para el
										Desarrollo les otorgará una beca mensual de 180 dólares para que se capaciten
										durante un máximo de 8 meses.
									</p>

									<p align="justify" class="landing-text text-color-gray">
										Es la oportunidad para que empresas, instituciones públicas y organizaciones
										sociales los capaciten para que desarrollen habilidades, aprovechen su talento y
										comiencen su experiencia laboral.
									</p>
								</div>
							</el-col>
						</el-row>

					</div>
				</section>


				<section class="section-2 static-gray">
					<el-row class="landing-frame ">
						<el-col :span="24">
							<el-row class="margin-top-20">
								<el-col :span="18"
								        :offset="3"
								        align="center">


									<el-card shadow="never" class="background-yellow">
										<div class="landing-text text-color-red" style="text-align: center">
											<label>
												Si ya te registraste y cuentas con tu usuario y tu contraseña
											</label>
											<br>
											<br>
											<el-button type="danger" plain @click="$router.push('/login')">
												INICIA SESIÓN AQUÍ <i class="fa fa-sign-in-alt"></i>
											</el-button>

										</div>
									</el-card>

								</el-col>
							</el-row>


							<el-row>

								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" align="center">

									<div class="grid-content">

										<el-card class="card-dashboard yellow-box text-color-white">
											<div slot="header"
											     style="text-align: center;height: 100px">
												<h3>
													BECARIOS
												</h3>
												<h4>
													(Jóvenes)
												</h4>
											</div>
                                            <el-button type="warning"
                                                       style="position: relative;top: 20px;margin-bottom: 50px;"
                                                       @click="enableRegistrationYoungs ? $router.push('/registro/becarios') : messageNotification() "
                                                       class="big-button button-orange">
                                                Regístrate
                                            </el-button>
                                            <br/>
											<div>
												<el-image fit="fill"
												          class="image-center"
												          :src="firstImg"
												          style="width: 65%;vertical-align: middle;display: inline-block; "
												          width="65%"
												>
													<div slot="error" class="image-slot">
														<i class="el-icon-picture-outline"></i>
													</div>
												</el-image>
											</div>

										</el-card>

									</div>

								</el-col>


								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" align="center">

									<div class="grid-content center-align">


										<el-card class="card-dashboard green-box text-color-white">
											<div slot="header"
											     style="text-align: center;height: 100px">
												<h3>
													TUTORES
												</h3>
												<h4>
													(Empresas, instituciones públicas y organizaciones sociales)
												</h4>
											</div>
                                            <el-button type="success"
                                                       style="position: relative;top: 20px;margin-bottom: 50px;"
                                                       @click="enableRegistrationTutors ? $router.push('/registro/tutores') : messageNotification()"
                                                       class="big-button button-green">
                                                Regístrate
                                            </el-button>

											<div>

												<el-image fit="fill"
												          class="image-center"
												          :src="secondImg"
												          style="width: 65%;vertical-align: middle;display: inline-block; "
												          width="65%">
													<div slot="error" class="image-slot">
														<i class="el-icon-picture-outline"></i>
													</div>
												</el-image>

											</div>

										</el-card>

									</div>


								</el-col>

							</el-row>

							<el-row class="margin-top-20">
								<el-col :span="18"
								        :offset="3"
								        align="center">


									<div style="text-align: center">
										<p align="center" class=" text-color-white font-small">
											Este Programa es público, ajeno a cualquier partido político.
											Queda prohibido el uso para fines distintos a los establecidos en el
											programa.
										</p>
									</div>

								</el-col>
							</el-row>


							<el-row class="margin-top-20">
								<el-col :span="18"
								        :offset="3"
								        align="center">
									<el-card shadow="never" class="background-yellow">


										<el-button type="text" class="guidelines-text"
										           style="text-align: center">

											<p style="display: inline-block;">
												LINEAMIENTOS DEL PROGRAMA
											</p>

											<el-image fit="fill"
											          class="image-center"
											          src="/img/pdf.jpg"
											          style="width: 30px;vertical-align: middle;display: inline-block; "
											          width="30px">
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>

										</el-button>

									</el-card>
								</el-col>
							</el-row>
							<br><br>

						</el-col>
					</el-row>


				</section>

			</main>
		</div>

		<div v-if="isHondurasProgram()">
			<main class="wrapper-parallax">

				<section class="section-1  parallax bg1">
					<div class="home-landing">

						<el-row class="landing-frame">

							<el-col align="center"
							        :xs="{ span: 24, offset:0}"
							        :sm="{ span: 24, offset:0}"
							        :md="{ span: 18, offset: 3}"
							        :lg="{ span: 12, offset:6}"
							        :xl="{ span: 12, offset: 6}">
								<div class="landing-middle all-padding">
									<p class="landing-text text-color-gray">
										Jóvenes Construyendo el Futuro en Honduras es un programa que busca que jóvenes
										entre 18 a 29 años de edad puedan capacitarse en el trabajo. El Fondo México por
										medio de la Agencia Mexicana de Cooperación Internacional para el Desarrollo les
										otorgará una beca mensual para que se capaciten durante un máximo de 8 meses.
									</p>

									<p align="justify" class="landing-text text-color-gray">
										Es la oportunidad para que empresas, instituciones públicas y organizaciones
										sociales los capaciten para que desarrollen habilidades, aprovechen su talento y
										comiencen su experiencia laboral.
									</p>
								</div>
							</el-col>
						</el-row>

					</div>
				</section>


				<section class="section-2 static-gray">
					<el-row class="landing-frame ">
						<el-col :span="24">
							<el-row class="margin-top-20">
								<el-col :span="18"
								        :offset="3"
								        align="center">


									<el-card shadow="never" class="background-yellow">
										<div class="landing-text text-color-red" style="text-align: center">
											<label>
												Si ya te registraste y cuentas con tu usuario y tu contraseña
											</label>
											<br>
											<br>
											<el-button type="danger" plain @click="$router.push('/login')">
												INICIA SESIÓN AQUÍ <i class="fa fa-sign-in-alt"></i>
											</el-button>

										</div>
									</el-card>

								</el-col>
							</el-row>


							<el-row>

								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" align="center">

									<div class="grid-content">

										<el-card class="card-dashboard yellow-box text-color-white">
											<div slot="header"
											     style="text-align: center;height: 100px">
												<h3>
													BECARIOS
												</h3>
												<h4>
													(Jóvenes)
												</h4>
											</div>
                                            <el-button type="warning"
                                                       style="position: relative;top: 20px;margin-bottom: 50px;"
                                                       @click="enableRegistrationYoungs ? $router.push('/registro/becarios') : messageNotification()"
                                                       class="big-button button-orange;">
                                                Regístrate
                                            </el-button>
                                            <br/>
											<div>
												<el-image fit="fill"
												          class="image-center"
												          :src="firstImg"
												          style="width: 65%;vertical-align: middle;display: inline-block; "
												          width="65%"
												>
													<div slot="error" class="image-slot">
														<i class="el-icon-picture-outline"></i>
													</div>
												</el-image>
											</div>

										</el-card>

									</div>

								</el-col>


								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" align="center">

									<div class="grid-content center-align">


										<el-card class="card-dashboard green-box text-color-white">
											<div slot="header"
											     style="text-align: center;height: 100px">
												<h3>
													TUTORES
												</h3>
												<h4>
													(Empresas, instituciones públicas y organizaciones sociales)
												</h4>
											</div>
                                            <el-button type="success"
                                                       style="position: relative;top: 20px;margin-bottom: 50px;"
                                                       @click="enableRegistrationTutors ? $router.push('/registro/tutores') : messageNotification()"
                                                       class="big-button button-green">
                                                Regístrate
                                            </el-button>
                                            <br/>
											<div>

												<el-image fit="fill"
												          class="image-center"
												          :src="secondImg"
												          style="width: 65%;vertical-align: middle;display: inline-block; "
												          width="65%">
													<div slot="error" class="image-slot">
														<i class="el-icon-picture-outline"></i>
													</div>
												</el-image>

											</div>

										</el-card>

									</div>


								</el-col>

							</el-row>

							<el-row class="margin-top-20">
								<el-col :span="18"
								        :offset="3"
								        align="center">


									<div style="text-align: center">
										<p align="center" class=" text-color-white font-small">
											Este Programa es público, ajeno a cualquier partido político.
											Queda prohibido el uso para fines distintos a los establecidos en el
											programa.
										</p>
									</div>

								</el-col>
							</el-row>


							<el-row class="margin-top-20">
								<el-col :span="18"
								        :offset="3"
								        align="center">
									<el-card shadow="never" class="background-yellow">


										<el-button type="text" class="guidelines-text"
										           style="text-align: center">

											<p style="display: inline-block;">
												LINEAMIENTOS DEL PROGRAMA
											</p>

											<el-image fit="fill"
											          class="image-center"
											          src="/img/pdf.jpg"
											          style="width: 30px;vertical-align: middle;display: inline-block; "
											          width="30px">
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>

										</el-button>

									</el-card>
								</el-col>
							</el-row>
							<br><br>

						</el-col>
					</el-row>


				</section>
			</main>
		</div>

	</div>
</template>

<script>

    import programMixin from '../../../mixins/programMixin';

	export default {
        mixins:[programMixin],
		data() {
			return {
				firstImg: this.isSalvadorProgram() ? '/img/landing/jovenes.gif' : '/img/landing/jovenes_h.gif',
				secondImg: this.isSalvadorProgram() ? '/img/landing/empresas.gif' : '/img/landing/empresas_h.gif',
				systemProgramId: this.getProgramSystem(),
                enableRegistrationYoungs:null,
                enableRegistrationTutors:null,
			}
		},
        mounted(){
            this.getStatusRegistration();
        },
        methods:{
            getStatusRegistration(){
                axios.get('check-status').then(response=>{
                    if(response.data.success == true){
                        this.enableRegistrationYoungs = response.data.youngs;
                        this.enableRegistrationTutors = response.data.tutors;
                    }
                }).catch(error=>console.log(error)).finally(()=>{});
            },
            messageNotification() {
        this.$alert('Agradecemos tu interés por participar en este proyecto, por el momento el registro no está disponible.', 'Notificación', {
          confirmButtonText: 'Cerrar',
          callback: action => {
            /* this.$message({
              type: 'info',
              message: `action: ${ action }`
            }); */
          }
        });
      }
        }
	}
</script>

<style scoped>

	.landing-frame {
		display: flex;
		align-items: center;
		min-height: 40vh;
	}

	.landing-text {
		font-size: 1em;
		text-align: justify;
		font-weight: bold;
	}

	.landing-middle {
		display: block;
		margin: 0 auto;
	}


</style>
